import { defineMessages } from 'react-intl-next';
export const messages = defineMessages({
  issueTypesColumnHeader: {
    id: 'jira-common.ListProjectForms.AssociatedIssueTypes',
    defaultMessage: 'Issue type',
    description: 'A table column heading showing issue types associated with a project form.'
  },
  lastUpdatedColumnHeader: {
    id: 'jira-common.ListProjectForms.LastUpdated',
    defaultMessage: 'Last updated',
    description: 'A table column heading for the timestamp for the last update of a project form.'
  },
  nameColumnHeader: {
    id: 'form-system.general.Form',
    defaultMessage: 'Name',
    description: 'The Name column header in the Project Forms list.'
  },
  requestTypesColumnHeader: {
    id: 'jira-common.ListProjectForms.AssociatedRequestTypes',
    defaultMessage: 'Request type',
    description: 'A table column heading showing request types associated with a project form.'
  },
  emptyFormName: {
    id: 'jira-common.ListProjectForms.EmptyFormName',
    defaultMessage: 'Untitled Form',
    description: 'A placeholder for a form with an empty name.'
  }
});